import React from 'react';

import { SVGPropsType } from 'src/types';

function Day(props: SVGPropsType) {
    const { fill, stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_4567_78873)">
                <path
                    d="M8.00002 11.8333C9.84097 11.8333 11.3334 10.3409 11.3334 8.49999C11.3334 6.65904 9.84097 5.16666 8.00002 5.16666C6.15907 5.16666 4.66669 6.65904 4.66669 8.49999C4.66669 10.3409 6.15907 11.8333 8.00002 11.8333Z"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 1.16666V2.49999"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14.5V15.8333"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.81335 3.31332L3.76002 4.25999"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.24 12.74L13.1867 13.6867"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.666687 8.5H2.00002"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8.5H15.3333"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.81335 13.6867L3.76002 12.74"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.24 4.25999L13.1867 3.31332"
                    stroke={stroke}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4567_78873">
                    <rect width="16" height="16" fill={fill} transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default Day;
